interface Props {
  src: string
  fullsize?: string
  isVideo?: boolean
  playlistUrl?: string
}

export function TilePreview({ src, fullsize, isVideo, playlistUrl }: Props) {
  if (isVideo && playlistUrl) {
    return (
      <video
        src={playlistUrl}
        poster={src}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        className="h-full w-full object-cover transition group-hover:scale-105"
      />
    )
  }
  return (
    <img
      src={fullsize ?? src}
      alt=""
      className="h-full w-full object-cover transition group-hover:scale-105"
      referrerPolicy="no-referrer"
    />
  )
}
